import React from 'react';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

class WordCounter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      count: props.value
    };
  }

  componentDidMount () {
    PubSub.subscribe('DICTATION_ON_CHANGE', (_msg, data) => this.onChange(data));
  }

  getWordCount(editorState) {
    const chunkDelimitatorRegex = new RegExp(gon.chunkDelimitatorRegex, 'mgi');
    const formatRegex = new RegExp(gon.formatRegex, 'mgi');  // new line, carriage return, line feed
    const apostropheRegex = new RegExp(gon.apostropheRegex, 'mgi');
    const compoundWordRegex = new RegExp(gon.compoundWordRegex, 'mgi');
    const specialCharRegex = new RegExp(gon.specialCharRegex, 'mgi');

    const plainText = editorState.getCurrentContent().getPlainText('');

    // Remove chunk delimitator
    const stringWithoutChunkDelimitator = plainText.replace(chunkDelimitatorRegex, ' ');

    // Remove formating chars
    const stringWithoutFormatChars = stringWithoutChunkDelimitator.replace(formatRegex, ' ').trim();

    // Split words w/ apostrophe
    const stringWithoutApostrophe = stringWithoutFormatChars.replace(apostropheRegex, ' ');

    // Merge compound words
    const stringWithoutCompoundWord = stringWithoutApostrophe.replace(compoundWordRegex, '');

    // Remove special chars
    const cleanString = stringWithoutCompoundWord.replace(specialCharRegex, '');

    const wordArray = cleanString.match(/\S+/g);  // matches words according to whitespace
    return wordArray ? wordArray.length : 0;
  }

  onChange (editorState) {
    this.setState({ count: this.getWordCount(editorState) });
  }

  render() {
    let wordCounterStateClass;

    if (this.state.count === this.props.maxLength) {
      wordCounterStateClass = "text-success font-bold";
    } else {
      wordCounterStateClass = "text-danger font-bold";
    }

    return (
      <div className={`${wordCounterStateClass}`}>{this.state.count}</div>
    );
  }
}

WordCounter.propTypes = {
  value: PropTypes.number,
  maxLength: PropTypes.number,
};

WordCounter.defaultProps = {
  value: 0
};

export default WordCounter;
